import React from 'react';
import Navbar from '../components/Navbar';
import CaseStudy from '../components/CaseStudy';
import '../index.css';

const CaseStudyPage = () => {
    return(
        <>
            <Navbar/>
            <CaseStudy/>
        </>
    );
}

export default CaseStudyPage;
